import React, { useMemo } from 'react';
import { Box, Link, Paper, Typography, useTheme } from '@mui/material';
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { SxProps } from '@mui/material/styles';

const container: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  alignItems: 'center',
  p: '50px',
  maxWidth: '500px',
  textAlign: 'center'
};

type Props = {
  redirectType: 'success' | 'failed';
  title: string;
  message: string;
};

export const RedirectCard: React.FC<Props> = ({
  redirectType,
  title,
  message
}) => {
  const { palette } = useTheme();

  const { iconColor, icon, supportLink } = useMemo(() => {
    if (redirectType === 'success') {
      return {
        title,
        message,
        iconColor: palette.successV2.main,
        icon: <CheckCircleOutline fontSize="inherit" />
      };
    }

    return {
      iconColor: palette.error.main,
      icon: <ErrorOutline fontSize="inherit" />,
      supportLink: (
        <Link
          href="mailto:support@joinpopp.com?subject=External calendar connection failed"
          variant="inherit"
        >
          Popp's support team
        </Link>
      )
    };
  }, [
    redirectType,
    title,
    message,
    palette.error.main,
    palette.successV2.main
  ]);

  return (
    <Paper sx={container} elevation={2}>
      <Box color={iconColor} fontSize="50px">
        {icon}
      </Box>
      <Box>
        <Typography variant="h4" sx={{ fontSize: '30px', mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body1" color={palette.text.primary}>
          {message}
          {supportLink && <> {supportLink}</>}
        </Typography>
      </Box>
    </Paper>
  );
};
